enum BlogTypes {
  TENANT = 'tenant',
  ADVERTISER = 'advertiser',
  LANDING = 'landing',
  PRESS = 'press',
  COUNTRY = 'country',
  CITY = 'city',
}

export default BlogTypes;
